"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemSchema = void 0;
var _zod = require("zod");
const itemBaseSchema = _zod.z.object({
  itemPath: _zod.z.string(),
  title: _zod.z.string(),
  url: _zod.z.string().nullish(),
  icon: _zod.z.string().nullish(),
  openInNewTab: _zod.z.boolean().nullish(),
  isViewable: _zod.z.boolean().nullish()
});
const menuItemSchema = exports.menuItemSchema = itemBaseSchema.extend({
  subItems: _zod.z.lazy(() => menuItemSchema.array())
});
